import { Skeleton } from 'antd';
import { Suspense, lazy } from 'react';
import type { IdeaBodyEditorProps } from '../IdeaBodyEditor/IdeaBodyEditor';

const IdeaBodyEditorLazy = lazy(() =>
  import('../IdeaBodyEditor/IdeaBodyEditor').then((m) => ({ default: m.IdeaBodyEditor })),
);

// Suspense stays inside so Form.Item can inject value/onChange directly.
export const RichTextField = (props: IdeaBodyEditorProps) => (
  <Suspense fallback={<Skeleton.Input active style={{ width: '100%', height: props.compact ? 100 : 200 }} />}>
    <IdeaBodyEditorLazy {...props} />
  </Suspense>
);
